import { Box, HStack, Text, Button, Flex, Modal, ModalBody, ModalContent, ModalOverlay, Spinner, Switch, Tooltip } from "@chakra-ui/react";
import { GET_CLASSIFIED_USER } from "constants/endpoints";
import useApi from "hooks/useApi";
import { memo, useCallback, useEffect, useMemo, useState } from "react";
import ReactJson from "react-json-view";
import JSONTable from "./JSONTable";
import { IoMdCheckmark, IoMdRefresh, IoMdShare } from "react-icons/io";
import { showToast } from "components/toast/Toast";
import { IoIosArrowForward } from "react-icons/io";
import { IoIosArrowBack } from "react-icons/io";
import ShareToWhatsapp from "./ShareToWhatsapp";
import { CREATE_USER } from "constants/endpoints";


const JSONModal = ({ isOpen, onClose, allData, currentIndex, setCurrentIndex, refreshTableData, onEditComment }) => {
  const { apiCall, loading } = useApi();
  const [isShareModalOpen,setIsShareModalOpen]=useState(false)
  const [jsonData, setJsonData] = useState(null);
  const [adminRole, setAdminRole] = useState();
  const [gender, setGender] = useState(null);
  const [isAdminVerified, setIsAdminVerified] = useState(null);
  const [isLeadAutomated, setIsLeadAutomated] = useState(null);

  const tableData = useMemo(() => allData?.[currentIndex], [allData, currentIndex])
  const getLatestClassificationData = useCallback(async () => {
    try {
      const res = await apiCall.post(`${GET_CLASSIFIED_USER}/`, {
        userId: tableData?.user_id ?? tableData?._id
      })

      if (res?.data?.success === false) {
        throw new Error(res?.data?.error);
      } else {
        setJsonData(res?.data);
        setGender(res?.data?.user_info?.gender)
        refreshTableData();
        setAdminRole(res?.data?.user_info?.classified_primary_role)
      }
    } catch (error) {
      showToast({
        message: error?.message ?? "Failed to update user classification",
        success: false,
        customStyle: {
          background: "#ff4d4f",
          color: "#fff",
          padding: "10px",
        },
      })
    }
  }, [tableData, apiCall, refreshTableData])

  const confirmClassification = useCallback(async (admin_verified, enable_lead_automation) => {
    try {
      const res = await apiCall.patch(`${CREATE_USER}/`, {
        _id: tableData?.user_id ?? tableData?._id,
        admin_verified,
        classified_primary_role: adminRole,
        gender,
        enable_lead_automation
      })

      if (res?.data?.success === false) {
        throw new Error(res?.data?.error);
      } else {
        getUserClassification();
        refreshTableData();
      }
    } catch (error) {
      showToast({
        message: error?.message ?? "Failed to update user",
        success: false,
        customStyle: {
          background: "#ff4d4f",
          color: "#fff",
          padding: "10px",
        },
      })
    }
  }, [tableData, apiCall, refreshTableData, isAdminVerified, adminRole, gender])

    const getUserClassification = useCallback(async () => {
    try {
      const res = await apiCall.get(`${GET_CLASSIFIED_USER}/${tableData?.user_id ?? tableData?._id}`)

      if (res?.data?.success === false) {
        throw new Error(res?.data?.error);
      } else {
        setJsonData(res?.data);
        setGender(res?.data?.user_info?.gender)
      }
    } catch (error) {
      console.log(error)
      if(error.status === 404){
        getLatestClassificationData();
      }
      showToast({
        message: error?.message ?? "Failed to get user classification",
        success: false,
        customStyle: {
          background: "#ff4d4f",
          color: "#fff",
          padding: "10px",
        },
      })
    }
  }, [tableData, apiCall, refreshTableData])

  const goToNext=()=>{
    setCurrentIndex(currentIndex+1)
  }

  const goBack=()=>{
    setCurrentIndex(currentIndex-1)
  }
  useEffect(() => {
    getUserClassification()
  }, [currentIndex])

  useEffect(()=>{
    setAdminRole(jsonData?.user_info?.classified_primary_role)
    setIsAdminVerified(jsonData?.user_info?.admin_verified || false);
    setIsLeadAutomated(jsonData?.user_info?.enable_lead_automation || false);
  },[jsonData?.user_info]);

  const onVerifyAdmin=async (verified)=>{
    setIsAdminVerified(verified)
    await confirmClassification(verified)
  }

  const onChnageLeadAutomation=async (enableAutomation)=>{
    setIsLeadAutomated(enableAutomation)
    await confirmClassification(isAdminVerified, enableAutomation)
  }

  return <Modal isOpen={isOpen} onClose={onClose} size="full">
    <ModalOverlay />
    <ModalContent>
      <ModalBody>
        <Flex gap={2} >
          <Flex gap={2} zIndex={10} position={'fixed'} right={6} top={4}>
            <HStack spacing={3}>
               <Switch
                isChecked={isLeadAutomated}
                onChange={(e)=>onChnageLeadAutomation(e.target.checked)}
                size={'md'}
                colorScheme={'green'}
              />
              <Text fontSize="sm" opacity={0.85} userSelect="none">
                {isLeadAutomated ? "Enabled Lead Automation" : "Disabled Lead AUtomation"}
              </Text>
              <Switch
                isChecked={isAdminVerified}
                onChange={(e)=>onVerifyAdmin(e.target.checked)}
                size={'md'}
                colorScheme={'green'}
              />
              <Text fontSize="sm" opacity={0.85} userSelect="none">
                {isAdminVerified ? "Verified" : "Not Verified"}
              </Text>
            </HStack>
            <Button onClick={() => setIsShareModalOpen(true)}><IoMdShare size={20} /></Button>
            <Button variant="outline" borderRadius={"full"} onClick={()=>getLatestClassificationData()}>
              <IoMdRefresh size={20} />
            </Button>
            <Button variant="outline" borderRadius={"full"}  onClick={onClose}>
              x
            </Button>
          </Flex>
          {loading ? (
            <Flex width={'100%'} height={'400px'} align={'center'} justify={'center'} >
              <Spinner size="lg" color="#22acee" thickness="6px" />
            </Flex>
          ) : (
              <Flex direction={'column'} gap={'20px'} width={'full'}>
                <Button
                  position="fixed"
                  top="50%"
                  variant="solid"
                  bgColor={'blue'}
                  rounded={'full'}
                  width={10}
                  height={10}
                  color={'white'}
                  padding={0}
                  disabled={currentIndex===0}
                  left="20px"
                  zIndex={20}
                  onClick={goBack}
                >
                 <IoIosArrowBack />
                </Button>

                <Button
                  position="fixed"
                  top="50%"
                  variant="solid"
                  rounded={'full'}
                  width={10}
                  height={10}
                  padding={0}
                  bgColor={'blue'}
                  color={'white'}
                  disabled={currentIndex=== allData?.length-1}
                  right="20px"
                  zIndex={20}
                  onClick={goToNext}
                >
                 <IoIosArrowForward />
                </Button>
                <JSONTable data={jsonData} tableData={tableData} onEditComment={onEditComment} adminRole={adminRole} setAdminRole={setAdminRole} setGender={setGender} gender={gender} confirmClassification={confirmClassification} />
                <ReactJson enableClipboard src={jsonData} />
              </Flex>
          )}
        </Flex>
        {jsonData && (
          <ShareToWhatsapp 
          isOpen={isShareModalOpen} 
          onClose={() => setIsShareModalOpen(false)} 
          userData={jsonData?.user_info} 
          defaultMessageType={jsonData?.classification?.primary_classification ?? 'post_property'}
          />
        )}
      </ModalBody>
    </ModalContent>
  </Modal>
}


export default memo(JSONModal)